<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>
        <action-button type="default" text="" icon="content_copy" :icon_only="true" @click="duplicate" v-if="coursetemplate.id" small />

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="view" @click="preview" :text="$t('global.preview')" v-if="coursetemplate.id" />
        <action-button type="delete" @click="del(coursetemplate.id)" v-if="$can('coursetemplate-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  name="coursetemplate.name"
                  v-model="coursetemplate.name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('coursetemplates.name')"
                  :error-messages="errors.collect('coursetemplate.name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  name="coursetemplate.certificate_display_name"
                  v-model="coursetemplate.certificate_display_name"
                  :label="$t('coursetemplates.certificate_display_name')"
                  :error-messages="errors.collect('coursetemplate.certificate_display_name')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-textarea
                  name="coursetemplate.short_description"
                  v-model="coursetemplate.short_description"
                  rows="3"
                  auto-grow
                  class="required-field"
                  v-validate="'required|max:300'"
                  :label="$t('coursetemplates.short_description')"
                  :error-messages="errors.collect('coursetemplate.short_description')"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 md6 lg6>
                <v-textarea
                  name="coursetemplate.long_description"
                  v-model="coursetemplate.long_description"
                  class="required-field"
                  v-validate="'required|max:1000'"
                  auto-grow
                  rows="3"
                  :label="$t('coursetemplates.long_description')"
                  :error-messages="errors.collect('coursetemplate.long_description')"
                ></v-textarea>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-select
                  name="coursetemplate.coursetemplatetype_id"
                  v-model="coursetemplate.coursetemplatetype_id"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_templates_type()"
                  :label="$t('coursetemplates.coursetemplatetype_id')"
                  :error-messages="errors.collect('coursetemplate.coursetemplatetype_id')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="coursetemplate.coursetypegroup_id"
                  ref="coursetypegroup_id"
                  v-model="coursetemplate.coursetypegroup_id"
                  @change="courseGroupChange(coursetemplate.coursetypegroup_id)"
                  :items="coursetypegroups"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypegroups.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('coursetemplate.coursetypegroup_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="coursetemplate.coursetype_id"
                  v-model="selectedCourseTypes"
                  :items="coursetypes"
                  item-text="fullname"
                  item-value="id"
                  :label="$t('coursetypes.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('coursetemplate.coursetype_id')"
                  multiple
                  clearable
                ></v-autocomplete>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12>
                                <v-autocomplete
                                name="coursetemplate.moduletemplate_id"
                                v-model="selectedModuleTemplates"
                                class="required-field"
                                v-validate="'required'"
                                :items="moduletemplates"
                                item-text="name"
                                item-value="id"
                                :label="$t('moduletemplates.title')"
                                autocomplete="new-password"
                                :error-messages="errors.collect('coursetemplate.moduletemplate_id')"
                                multiple
                                clearable
                                ></v-autocomplete>
                            </v-flex>-->

              <v-flex lg3 md3 sm6 xs12>
                <v-select
                  name="coursetemplate.status"
                  v-model="coursetemplate.status"
                  class="required-field"
                  v-validate="'required'"
                  item-text="text"
                  item-value="key"
                  :items="this.$dd_course_templates_status()"
                  :label="$t('coursetemplates.status')"
                  :error-messages="errors.collect('coursetemplate.status')"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex lg2 md3 sm3 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="coursetemplate.valid_for"
                  v-model="coursetemplate.valid_for"
                  v-validate="'numeric'"
                  :label="$t('coursetemplates.valid_for')"
                  :error-messages="errors.collect('coursetemplate.valid_for')"
                  :suffix="$t('coursetemplates.months')"
                  autocomplete="new-password"
                >
                  <help-text slot="append" :tooltip="$t('coursetemplates.valid_for_helptext')" />
                </v-text-field>
              </v-flex>
              <v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                <v-text-field
                  name="coursetemplate.price"
                  v-model="computedPrice"
                  @keypress="$keyDown_PriceOnly($event)"
                  :hint="'Format:' + PRICE_FORMAT"
                  :label="$t('coursetemplates.price')"
                  :error-messages="errors.collect('coursetemplate.price')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <!--<v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                                <v-text-field
                                    name="coursetemplate.price_proof"
                                    v-model="computedPriceProof"
                                    @keypress="$keyDown_PriceOnly($event)"
                                    :hint="'Format:' + PRICE_FORMAT"
                                    :label="$t('coursetemplates.price_proof')"
                                    :error-messages="errors.collect('coursetemplate.price_proof')"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>
                            <v-flex lg2 md3 sm6 xs12 v-if="coursetemplate.type == 1">
                                <v-text-field
                                    name="coursetemplate.price_vat"
                                    v-model="computedPriceVat"
                                    @keypress="$keyDown_PriceOnly($event)"
                                    :hint="'Format:' + PRICE_FORMAT"
                                    :label="$t('coursetemplates.price_vat')"
                                    :error-messages="errors.collect('coursetemplate.price_vat')"
                                    autocomplete="new-password"
                                ></v-text-field>
                            </v-flex>-->
              <v-flex xs12>
                <v-text-field
                  name="coursetemplate.info_link"
                  v-model="coursetemplate.info_link"
                  v-validate="'max:255'"
                  :label="$t('coursetemplates.info_link')"
                  :error-messages="errors.collect('coursetemplate.info_link')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <p class="text-left mb-0" v-if="coursetemplate.updated_by != null">
                  {{ $t("global.last_updated_by") + " " + coursetemplate.updated_by_name }}
                  {{ moment.utc(coursetemplate.updated_at).format(DATE_FORMAT + " " + TIME_FORMAT) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card class="mt-4">
          <v-app-bar dense text color="secondary">
            <v-toolbar-title class="subheading">{{ $t("coursetemplates.pdf_template") }}</v-toolbar-title>
          </v-app-bar>

          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12 lg5>
                <v-text-field
                  name="coursetemplate.pdf_title"
                  v-model="coursetemplate.pdf_title"
                  class="required-field"
                  v-validate="'required|max:100'"
                  :label="$t('coursetemplates.pdf_title')"
                  :error-messages="errors.collect('coursetemplate.pdf_title')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 lg7>
                <v-text-field
                  name="coursetemplate.pdf_description"
                  v-model="coursetemplate.pdf_description"
                  rows="3"
                  auto-grow
                  :label="$t('coursetemplates.pdf_description')"
                  :error-messages="errors.collect('coursetemplate.pdf_description')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-container class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12 lg5>
                      <v-flex xs12>
                        <action-button
                          type="new"
                          :text="$t('coursetemplates.upload_pdf_template')"
                          @click="showUploadTemplate"
                          class="ml-0 mb-5"
                        />

                        <div v-if="coursetemplate.id && coursetemplate.original_filename">
                          <p>
                            {{ coursetemplate.original_filename }}

                            <action-button
                              type="download"
                              small
                              class="text-right"
                              :icon_only="true"
                              @click="downloadTemplate(coursetemplate.filename, coursetemplate.original_filename)"
                            />
                            <action-button
                              type="delete"
                              small
                              class="text-right"
                              :icon_only="true"
                              @click="deleteTemplate(coursetemplate.id)"
                            />
                          </p>

                          <action-button
                            type="view"
                            :text="$t('coursetemplates.preview_pdf_template')"
                            @click="previewTemplate(coursetemplate.id)"
                            class="ml-0 mt-2"
                          />
                        </div>

                        <div v-if="!coursetemplate.id && pdfTemplateFile">
                          <p>
                            {{ pdfTemplateFile.name }}
                            <action-button type="delete" small class="text-right" :icon_only="true" @click="cancelUploadTemplate()" />
                          </p>
                        </div>
                      </v-flex>
                    </v-flex>
                    <v-flex xs12 lg7>
                      <v-flex xs12>
                        <!--<quill-editor
                            name="coursetemplate.pdf_content"
                            v-model="coursetemplate.pdf_content"
                            :options="editorOption"
                            :label="$t('coursetemplates.pdf_content')"
                            :error-messages="errors.collect('coursetemplate.pdf_content')"
                            :readonly="!allow_edit"
                        ></quill-editor>-->
                        <v-textarea
                          name="coursetemplate.pdf_content"
                          v-model="coursetemplate.pdf_content"
                          rows="3"
                          auto-grow
                          :label="$t('coursetemplates.pdf_content')"
                          :error-messages="errors.collect('coursetemplate.pdf_content')"
                        ></v-textarea>
                      </v-flex>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels :value="1" class="cstm-filter mt-4 elevation-0" v-if="coursetemplate.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              {{ $t("moduletemplates.title") }}

              <v-spacer></v-spacer>

              <v-flex xs2>
                <v-btn class="d-flex-inherit cstm-v-btn darken-2 float-right" color="success" @click.stop="modtemplistpopup_show" small>
                  <v-icon small>fas fa-plus</v-icon>
                  <span class="'d-none d-sm-inline cstm-v-btn-text">{{ $t("global.new") }}</span>
                </v-btn>
              </v-flex>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="elevation-1">
              <v-layout row wrap>
                <draggable v-model="cmDragged" handle=".drag-icon" class="full-width-draggable">
                  <v-flex xs12 v-for="moduletemplate in coursetemplate_moduletemplates" :key="moduletemplate.id">
                    <v-card>
                      <v-card-title class="body-1 mt-card-title">
                        <div class="body-2">
                          <v-icon class="drag-icon mr-2" dark small>fas fa-grip-vertical</v-icon>
                          {{ moduletemplate.name }}
                        </div>
                        <div class="caption ml-2" v-if="!moduletemplate.is_included">
                          ({{ $t("moduletemplates.price") }}: {{ moduletemplate.price }})
                        </div>
                        <v-spacer></v-spacer>
                        <!--<v-checkbox
                            name="moduletemplate.is_included"
                            v-model="moduletemplate.is_included"
                            :label="$t('moduletemplates.is_included')"
                            class="mt-0 mr-4 dark"
                            @change="updateSingleField(moduletemplate.id, 'is_included', moduletemplate.is_included)"
                            hide-details
                            dense
                        ></v-checkbox>-->
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_accomplishment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_accomplishment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.hide_in_enrolment"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.hide_in_enrolment") }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.select_visibility"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $dd_select_visibility(moduletemplate.select_visibility) }}</v-chip
                        >
                        <v-chip small label color="success darken-2" class="mr-2" v-if="moduletemplate.is_included"
                          ><v-icon small color="white lighten-1" class="mr-2">fas fa-check-square</v-icon>
                          {{ $t("moduletemplates.is_included") }}</v-chip
                        >
                        <action-button
                          type="delete"
                          @click="delModuleTemplate(coursetemplate.id, moduletemplate.id)"
                          :icon_only="true"
                          v-if="$can('coursetemplate-delete')"
                        />
                      </v-card-title>
                      <v-card-text v-if="moduletemplate.module_options && moduletemplate.module_options.length > 0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">
                                  {{ $t("moduleoptions.name") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("moduleoptions.price") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("moduleoptions.hours") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("moduleoptions.enrol_select") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("moduleoptions.mandatory_accomplishment") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("global.dd_select_visibility_expertise") }}
                                </th>
                                <th class="text-left">
                                  {{ $t("global.dd_select_visibility_course_certificate") }}
                                </th>
                              </tr>
                            </thead>
                            <tbody v-for="moduleoption in moduletemplate.module_options" :key="moduleoption.id">
                              <tr>
                                <td scope="row" :class="moduleoption.comment ? 'py-2' : ''">
                                  {{ moduleoption.name }}
                                  <p v-if="moduleoption.comment" class="font-italic mb-0">( {{ moduleoption.comment }} )</p>
                                </td>
                                <td scope="row">{{ moduleoption.price }}</td>
                                <td scope="row">{{ moduleoption.hours }}</td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.enrol_select)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.mandatory_accomplishment)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_expertise)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                                <td scope="row">
                                  <v-simple-checkbox
                                    :value="Boolean(moduleoption.add_to_course_certificate)"
                                    :readonly="true"
                                    hide-details
                                  ></v-simple-checkbox>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </draggable>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-form>

    <v-dialog v-model="showUploadTemplateForm" persistent max-width="960px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-form ref="form">
            <v-container grid-list-md>
              <v-card>
                <v-app-bar flat dense color="secondary">
                  <v-toolbar-title class="subheading">{{ $t("coursetemplates.upload_pdf_template") }}</v-toolbar-title>
                </v-app-bar>

                <v-card-text class="pa-4">
                  <ValidationObserver ref="pdfTemplateFile">
                    <v-flex xs12>
                      <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                        <v-file-input
                          v-model="pdfTemplateFile"
                          accept=".pdf"
                          color="primary"
                          counter
                          :placeholder="$t('coursetemplates.select_pdf_template')"
                          prepend-icon="attach_file"
                          outlined
                          :show-size="1000"
                          clearable
                          :error="errors.length > 0"
                          :error-messages="errors[0]"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip color="primary" dark label small>
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </ValidationProvider>
                    </v-flex>
                  </ValidationObserver>
                  <v-flex xs12>
                    <v-card
                      @drop.prevent="documentOnDrop($event)"
                      @dragover.prevent="document_dragover = true"
                      @dragenter.prevent="document_dragover = true"
                      @dragleave.prevent="document_dragover = false"
                      :class="{ 'grey lighten-2': document_dragover }"
                    >
                      <v-card-text>
                        <v-row class="d-flex flex-column" dense align="center" justify="center">
                          <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                            mdi-cloud-upload
                          </v-icon>
                          <p>{{ $t("global.drop_files_here") }}</p>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />

                  <action-button type="cancel" @click="cancelUploadTemplate" />
                  <action-button type="upload" @click="uploadTemplate()" :disabled="!pdfTemplateFile" />
                </v-card-actions>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </div>
    </v-dialog>

    <v-dialog v-model="showTypeForm" persistent max-width="500px">
      <div class="form-modal pa-4">
        <v-container class="pa-0">
          <v-card>
            <v-card-text class="pa-4">
              <p>{{ $t("coursetemplates.select_template_type") }}</p>
              <action-button
                type="default"
                :text="$t('global.dd_course_templates_type_normal')"
                class="d-block ml-0"
                @click="selectTemplateType(1)"
              />
              <p class="mt-1">
                {{ $t("coursetemplates.type_normal_helptext") }}
              </p>
              <action-button
                type="default"
                :text="$t('global.dd_course_templates_type_long')"
                class="d-block ml-0"
                @click="selectTemplateType(2)"
              />
              <p class="mt-1">{{ $t("coursetemplates.type_long_helptext") }}</p>
              <action-button type="cancel" color="error" :icon="null" class="d-block ml-0" @click="cancelTypeSelection" />
            </v-card-text>
          </v-card>
        </v-container>
      </div>
    </v-dialog>

    <moduleTemplateListPopup
      :show="showModuleTemplateListPopup"
      :except_ids="selectedModuleTemplates"
      @callback_modtemplistpopup_cancel="callback_modtemplistpopup_cancel"
      @callback_modtemplistpopup_submit="callback_modtemplistpopup_submit"
    />
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import draggable from "vuedraggable"
import moduleTemplateListPopup from "../../moduletemplates/partials/ModuleTemplateListPopup.vue"

export default {
  name: "CourseTypesForm",

  props: ["id"],

  components: {
    ValidationObserver,
    ValidationProvider,
    draggable,
    moduleTemplateListPopup
  },

  data() {
    return {
      page_title: "",
      predata: {},
      coursetemplate: {
        has_locale: false
      },
      coursetemplate_moduletemplates: [],
      coursetypes: [],
      coursetypegroups: [],
      moduletemplates: [],
      selectedCourseTypes: [],
      selectedModuleTemplates: [],
      showModuleTemplateListPopup: false,
      showUploadTemplateForm: false,
      showTypeForm: false,
      pdfTemplateFile: null,
      document_dragover: false,
      dictionary: {
        attributes: {
          "coursetemplate.name": this.$t("coursetemplates.name"),
          "coursetemplate.certificate_display_name": this.$t("coursetemplates.certificate_display_name"),
          "coursetemplate.short_description": this.$t("coursetemplates.short_description"),
          "coursetemplate.long_description": this.$t("coursetemplates.long_description"),
          "coursetemplate.coursetemplatetype_id": this.$t("coursetemplates.coursetemplatetype_id"),
          "coursetemplate.pdf_title": this.$t("coursetemplates.pdf_title"),
          "coursetemplate.pdf_description": this.$t("coursetemplates.pdf_description"),
          "coursetemplate.pdf_content": this.$t("coursetemplates.pdf_content"),
          "coursetemplate.info_link": this.$t("coursetemplates.info_link"),
          "coursetemplate.coursetype_id": this.$t("coursetypes.title"),
          "coursetemplate.moduletemplate_id": this.$t("moduletemplates.title"),
          "coursetemplate.price": this.$t("coursetemplates.price"),
          "coursetemplate.price_proof": this.$t("coursetemplates.price_proof"),
          "coursetemplate.price_vat": this.$t("coursetemplates.price_vat"),
          "coursetemplate.status": this.$t("coursetemplates.status")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.coursetemplate, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedPrice: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price)
      },
      set(val) {
        this.$set(this.coursetemplate, "price", this.$priceFormatSetter(val))
      }
    },
    computedPriceProof: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price_proof)
      },
      set(val) {
        this.$set(this.coursetemplate, "price_proof", this.$priceFormatSetter(val))
      }
    },
    computedPriceVat: {
      get() {
        return this.$priceFormatGetter(this.coursetemplate.price_vat)
      },
      set(val) {
        this.$set(this.coursetemplate, "price_vat", this.$priceFormatSetter(val))
      }
    },
    cmDragged: {
      get() {
        return this.coursetemplate_moduletemplates
      },
      set(list) {
        if (list) {
          var data = []
          var ctr = 1

          list.forEach((item, index) => {
            item.order = ctr

            data.push({ id: item.ctmt_id, order: item.order })

            ctr++
          })

          axios
            .put(this.API_URL + "coursetemplate/moduletemplateorder", {
              data: data
            })
            .then((res) => {
              this.coursetemplate_moduletemplates = list
              this.selectedModuleTemplates = this.coursetemplate_moduletemplates.map((a) => a.id)
            })
            .catch((err) => console.log(err))
        }
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      let lists = [
        {
          key: "coursetypegroups",
          module: "coursetypegroups",
          query: "show_all=true&sort_by=category&sort_order=asc"
        },
        {
          key: "moduletemplates",
          module: "moduletemplates",
          query: "show_all=true"
        }
      ]

      axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
        this.coursetypegroups = res.data.coursetypegroups
        this.moduletemplates = res.data.moduletemplates

        if (!this.id) {
          this.coursetemplate = {
            has_locale: false,
            status: this.$getDefaultDropdown(this.$dd_course_templates_status())
          }
          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.coursetemplate))

          this.setPageTitle()
          this.showTypeForm = true
        } else {
          this.title = this.$t("coursetemplates.update_title")

          axios
            .get(this.API_URL + "coursetemplate/" + this.id)
            .then((res) => {
              this.coursetemplate = res.data.data
              this.coursetemplate_moduletemplates = this.coursetemplate.moduletemplates

              // JSON stringify and parse to remove variable reactiveness
              this.predata = JSON.parse(JSON.stringify(this.coursetemplate))

              this.selectedCourseTypes = this.coursetemplate.coursetypes.map((a) => a.id)
              this.selectedModuleTemplates = this.coursetemplate.moduletemplates.map((a) => a.id)
              this.coursetemplate_moduletemplates = this.coursetemplate.moduletemplates

              this.courseGroupChange(this.coursetemplate.coursetypegroup_id)
              this.setPageTitle()
            })
            .catch((err) => console.log(err))
        }
      })
    },
    setPageTitle() {
      if (_.has(this.coursetemplate, "id")) {
        this.page_title = this.$t("coursetemplates.edit_coursetemplate", {
          name: this.coursetemplate.name
        })
      } else {
        this.page_title = this.$t("coursetemplates.new_coursetemplate")
      }
    },
    courseGroupChange(groupId) {
      axios
        .get(this.API_URL + "coursetypes?show_all=true&sort_by=category&sort_order=asc&query_coursetypegroup_id=" + groupId)
        .then((res) => {
          this.coursetypes = res.data.data

          let new_ctg = this.coursetypes.map((a) => a.id)
          _.remove(this.selectedCourseTypes, function(n) {
            return !new_ctg.includes(n)
          })

          this.$refs.coursetypegroup_id.focus()
        })
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this
            let user = this.$store.getters["auth/user"]

            if (!this.coursetemplate.id) {
              // Create
              axios
                .post(this.API_URL + "coursetemplate", {
                  name: this.coursetemplate.name,
                  certificate_display_name: this.coursetemplate.certificate_display_name,
                  short_description: this.coursetemplate.short_description,
                  long_description: this.coursetemplate.long_description,
                  coursetypegroup_id: this.coursetemplate.coursetypegroup_id,
                  coursetemplatetype_id: this.coursetemplate.coursetemplatetype_id,
                  coursetypes: this.selectedCourseTypes.join(","),
                  pdf_title: this.coursetemplate.pdf_title,
                  pdf_description: this.coursetemplate.pdf_description,
                  pdf_content: this.coursetemplate.pdf_content,
                  info_link: this.coursetemplate.info_link,
                  coursetype_id: this.coursetemplate.coursetype_id,
                  price: this.coursetemplate.price,
                  price_proof: this.coursetemplate.price_proof,
                  price_vat: this.coursetemplate.price_vat,
                  valid_for: this.coursetemplate.valid_for,
                  status: this.coursetemplate.status,
                  type: this.coursetemplate.type,
                  created_by: user.id
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.coursetemplate = res.data.data
                      vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

                      if (this.pdfTemplateFile) {
                        this.uploadTemplate()
                      }

                      vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates

                      vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
                      vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)
                      vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates

                      vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)
                      vm.setPageTitle()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/coursetemplates/edit/${vm.coursetemplate.id}`).catch(() => {})
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "coursetemplate", {
                  id: this.coursetemplate.id,
                  name: this.coursetemplate.name,
                  certificate_display_name: this.coursetemplate.certificate_display_name,
                  short_description: this.coursetemplate.short_description,
                  long_description: this.coursetemplate.long_description,
                  coursetypegroup_id: this.coursetemplate.coursetypegroup_id,
                  coursetemplatetype_id: this.coursetemplate.coursetemplatetype_id,
                  coursetypes: this.selectedCourseTypes.join(","),
                  moduletemplates: this.selectedModuleTemplates.join(","),
                  pdf_title: this.coursetemplate.pdf_title,
                  pdf_description: this.coursetemplate.pdf_description,
                  pdf_content: this.coursetemplate.pdf_content,
                  info_link: this.coursetemplate.info_link,
                  coursetype_id: this.coursetemplate.coursetype_id,
                  price: this.coursetemplate.price,
                  price_proof: this.coursetemplate.price_proof,
                  price_vat: this.coursetemplate.price_vat,
                  valid_for: this.coursetemplate.valid_for,
                  status: this.coursetemplate.status,
                  type: this.coursetemplate.type
                })
                .then((res) => {
                  vm.coursetemplate = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

                  vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates

                  vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
                  vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)

                  vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)
                  vm.setPageTitle()

                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/coursetemplates")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    delModuleTemplate(cid, mid) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/" + cid + "/moduletemplate/" + mid)
            .then((res) => {
              vm.coursetemplate = res.data.data
              vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
              vm.coursetemplate_moduletemplates = vm.coursetemplate.moduletemplates
              vm.selectedCourseTypes = vm.coursetemplate.coursetypes.map((a) => a.id)
              vm.selectedModuleTemplates = vm.coursetemplate.moduletemplates.map((a) => a.id)
              vm.courseGroupChange(vm.coursetemplate.coursetypegroup_id)
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    duplicate() {
      let vm = this

      this.$awn.confirm(
        this.$t("coursetemplates.duplicate_message"),
        () => {
          axios
            .post(this.API_URL + "coursetemplate/duplicate/" + this.coursetemplate.id)
            .then((res) => {
              let coursetemplate = res.data.data

              if (coursetemplate) {
                vm.$router.push(this.BACKEND_URL + "/coursetemplates/edit/" + coursetemplate.id)
                vm.init()
                vm.$awn.success(vm.$t("global.create_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        () => {
          return
        }
      )
    },
    modtemplistpopup_show() {
      this.showModuleTemplateListPopup = true
    },
    callback_modtemplistpopup_submit(data) {
      this.callback_modtemplistpopup_cancel()

      let ids = data.map((i) => i.id)
      let mt_ids = [...this.selectedModuleTemplates, ...ids]
      if (mt_ids) {
        axios
          .put(this.API_URL + "coursetemplate/moduletemplate", {
            id: this.coursetemplate.id,
            moduletemplates: mt_ids.join(",")
          })
          .then((res) => {
            let coursetemplate = res.data.data
            this.selectedModuleTemplates = coursetemplate.moduletemplates.map((a) => a.id)
            this.coursetemplate_moduletemplates = coursetemplate.moduletemplates
          })
          .catch((err) => console.log(err))
      }
    },
    callback_modtemplistpopup_cancel() {
      this.showModuleTemplateListPopup = false
    },
    showUploadTemplate() {
      this.showUploadTemplateForm = true
    },

    cancelUploadTemplate() {
      this.showUploadTemplateForm = false
      this.pdfTemplateFile = null
    },

    async uploadTemplate() {
      let vm = this
      let formData = new FormData()

      if(this.$refs.pdfTemplateFile) {
        const isValid = await this.$refs.pdfTemplateFile.validate()
        if (!isValid) {
          return
        }
      }

      if (this.coursetemplate.id) {
        formData.append("id", this.coursetemplate.id)
        formData.append("pdf_template_file", this.pdfTemplateFile)

        axios
          .post(this.API_URL + "coursetemplate/template/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then((res) => {
            vm.pdfTemplateFile = null

            vm.coursetemplate.filename = res.data.data.filename
            vm.coursetemplate.original_filename = res.data.data.original_filename

            vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))
            vm.cancelUploadTemplate()
          })
          .catch((err) => console.log(err))
      } else {
        this.showUploadTemplateForm = false
      }
    },
    async documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["pdf"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.pdfTemplateFile = file
          }
        }
      }

      if(this.$refs.pdfTemplateFile) {
        await this.$refs.pdfTemplateFile.validate()
      }
    },
    downloadTemplate(filename, original_filename) {
      axios({
        url: this.API_URL + "s3/download?file=" + filename,
        method: "GET",
        responseType: "arraybuffer"
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", original_filename)
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },

    deleteTemplate(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "coursetemplate/template/delete/" + id)
            .then((res) => {
              vm.coursetemplate.filename = res.data.data.filename
              vm.coursetemplate.original_filename = res.data.data.original_filename

              vm.predata = JSON.parse(JSON.stringify(vm.coursetemplate))

              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((error) => {
              console.log(error.response.data)
            })
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    previewTemplate(id) {
      axios({
        url: this.API_URL + "coursetemplate/template/preview",
        method: "POST",
        responseType: "arraybuffer",
        data: {
          id: id
        }
      })
        .then((response) => {
          if (this.$arrayBufferValidation(response.data)) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", "preview.pdf")
            link.click()
          }
        })
        .catch((error) => {
          console.log(error.response.data)
        })
    },

    updateSingleField(id, field, value) {
      let vm = this

      axios
        .put(this.API_URL + "moduletemplate/updatefield", {
          id: id,
          field: field,
          value: value
        })
        .then((res) => {})
        .catch((err) => console.log(err))
    },

    preview() {
      this.$router.push(this.BACKEND_URL + "/coursetemplates/preview/" + this.id)
    },

    selectTemplateType(type) {
      this.coursetemplate.type = type
      this.predata = JSON.parse(JSON.stringify(this.coursetemplate))
      this.showTypeForm = false
    },
    cancelTypeSelection() {
      this.showTypeForm = false
      this.$router.push(this.BACKEND_URL + "/coursetemplates")
    }
  }
}
</script>

<style>
.v-text-field__suffix {
  font-size: 12px;
  color: var(--v-accent-lighten1) !important;
}
.drag-icon:hover {
  cursor: pointer;
}
</style>
